import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Peter Noble
 * id E844FA32-E45E-4D71-B74C-34DFAD7F6830
 * name home-plus
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-plus.svg
 * tags
 * - Home Automation 
 */
export const HomePlusIcon = createSvgIcon(<><path d="M17 14H19V17H22V19H19V22H17V19H14V17H17V14M12 3L22 12H18C14.69 12 12 14.69 12 18C12 18.7 12.12 19.37 12.34 20H5V12H2L12 3Z" /></>, 'HomePlusIcon');
export default HomePlusIcon